/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Learn_FootnoteInputs */

const en_gc_resources_learn_footnote = /** @type {(inputs: Gc_Resources_Learn_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the guides with a copy of your workbook. Alpha features may change.`)
};

const zh_gc_resources_learn_footnote = /** @type {(inputs: Gc_Resources_Learn_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建议使用工作簿副本尝试指南。Alpha 版本功能可能发生变化。`)
};

/**
* | output |
* | --- |
* | "Try the guides with a copy of your workbook. Alpha features may change." |
*
* @param {Gc_Resources_Learn_FootnoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_learn_footnote = /** @type {((inputs?: Gc_Resources_Learn_FootnoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Learn_FootnoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_learn_footnote(inputs)
	return zh_gc_resources_learn_footnote(inputs)
});
export { gc_resources_learn_footnote as "gc.resources.learn.footnote" }